import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAnnouncementVisible: true, // Default visibility is true
  announcements: [], // Array to store announcements
};

const AnnouncementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {
    // Action to toggle visibility
    toggleAnnouncementVisibility: (state) => {
      state.isAnnouncementVisible = !state.isAnnouncementVisible;
    },
    // Action to set visibility explicitly
    setAnnouncementVisibility: (state, action) => {
      state.isAnnouncementVisible = action.payload;
    },

    // addAnnouncement: (state, action) => {
    //   state.announcements.push(action.payload);
    // },

    // updateAnnouncement: (state, action) => {
    //   const index = state.announcements.findIndex(
    //     (announcement) => announcement.id === action.payload.id
    //   );
    //   if (index !== -1) {
    //     state.announcements[index] = action.payload;
    //   }
    // },

    // deleteAnnouncement: (state, action) => {
    //   state.announcements = state.announcements.filter(
    //     (announcement) => announcement.id !== action.payload
    //   );
    // },
    // Action to set all announcements (e.g., after fetching from the API)
    setAnnouncements: (state, action) => {
      state.announcements = action.payload;
    },
  },
});

// Export actions
export const {
  toggleAnnouncementVisibility,
  setAnnouncementVisibility,
  // addAnnouncement,
  // updateAnnouncement,
  // deleteAnnouncement,
  setAnnouncements,
} = AnnouncementSlice.actions;

// Export reducer
export default AnnouncementSlice.reducer;
